<template>
	<flickity
		ref="flickity"
		@init="onInit"
		:options="flickityOptions"
	>
		<slot></slot>
	</flickity>
</template>

<script>

	import Flickity from './Flickity.vue';

	export default {
		name: 'HeroHomeCarousel',
		components: {
			Flickity
		},
		props: {
			title: {

			},
			pagination: {
				default: false
			},
			pagination_alt: {
				default: false
			},
			itemclass: {
				type: String,
				default: '.hero-slider__slide'
			}
		},
		data() {
			return {
				flickityOptions: {
					contain: true,
					pageDots: false,
					wrapAround: true,
					imagesLoaded: true,
					adaptiveHeight: true,
					setGallerySize: false,
					cellAlign: 'left',
					// pagination: false,
					// groupCells: true,
					cellSelector: this.itemclass,
					prevNextButtons: this.pagination_alt,
				}
			}
		},
		methods: {
			slidesLoaded () {
				this.$nextTick(() => {
					setTimeout(() => this.$refs.flickity.resize(),1000);
				});
			},
			next() {
				this.$refs.flickity.next();
			},
			previous() {
				this.$refs.flickity.previous();
			},
			onInit() {
				var slider = this.$refs.flickity;
				var arrowPrev = document.querySelectorAll('.hero-navigation .button-arrows .arrow-prev')[0];
				var arrowNext = document.querySelectorAll('.hero-navigation .button-arrows .arrow-next')[0];
				var buttons = document.querySelectorAll('.hero-navigation .slider-pager .button');
				var statusNr = document.querySelector('.hero-navigation .gallery-status');
				var selector;
				var i;

				arrowPrev.addEventListener('click', function() {
					slider.previous();
				});
				arrowNext.addEventListener('click', function() {
					slider.next();
				});

				for(var button of buttons){
					button.addEventListener('click', function() {
						selector = this.getAttribute('data-selector');
						slider.select(selector);
					});
				}

				slider.on('select', function(index) {
					for (i = 0; i < buttons.length; ++i){
						if(buttons[i].classList.contains('is-selected')) {
							buttons[i].classList.remove('is-selected');
						}
					}
					buttons[index].classList.add('is-selected');

					var cellNr = this.selectedIndex + 1;
					statusNr.innerHTML = '0' + cellNr;
				});

			}
		},
		mounted() {
			this.slidesLoaded();
		}
	}

</script>
